import type {InvalidateQueryFilters, QueryKey} from '@github-ui/react-query'

export type QueryKeyOrFilters = QueryKey | InvalidateQueryFilters

const isQueryKey = (queryKeyOrFilters: QueryKeyOrFilters): queryKeyOrFilters is QueryKey =>
  Array.isArray(queryKeyOrFilters)

export const toQueryFilters = (queryKeyOrFilters: QueryKeyOrFilters) => {
  return isQueryKey(queryKeyOrFilters) ? {queryKey: queryKeyOrFilters, exact: true} : queryKeyOrFilters
}
